/* eslint-disable */
const hash = {
  "en-US": "ee9920a2",
  "de-DE": "9db17e5c",
  "es-ES": "85f17586",
  "fr-FR": "884bcb80",
  "id-ID": "cabff555",
  "it-IT": "f85be75c",
  "jp-JP": "94df9516",
  "ko-KO": "08bb12b2",
  "nl-NL": "75828f10",
  "pl-PL": "e720bb0f",
  "pt-PT": "d012a38a",
  "ru-RU": "efb3dd38",
  "tr-TR": "a890ab4e",
  "vi-VN": "db55cb84",
  "zh-CN": "0075aafc",
  "zh-TW": "f55cc3fc",
  "sv-SE": "ab1a127d",
  "control": "9fad2ad4",
  "plan-details": "eea786a7",
  "gov-EN": "91350607",
  "en-GB": "3c03c24c"
}
export default hash
